import { WELCOME_MESSAGE, WELCOME_SUBTITLE } from '../constants';

interface Props {
  onContinue: () => void;
}

export function WelcomeScreen({ onContinue }: Props) {
  return (
    <div className="welcome-overlay" role="dialog" aria-labelledby="welcome-title">
      <div className="welcome-card">
        <div className="welcome-confetti" aria-hidden="true">
          {['do', 're', 'mi', 'fa', 'sol', 'la', 'si'].map((n, i) => (
            <span key={n} className={`confetti-dot confetti-${i}`} />
          ))}
        </div>
        <h1 id="welcome-title" className="welcome-title">
          {WELCOME_MESSAGE}
        </h1>
        <p className="welcome-subtitle">{WELCOME_SUBTITLE}</p>
        <button type="button" className="btn btn-primary welcome-btn" onClick={onContinue}>
          ¡Empezar!
        </button>
      </div>
    </div>
  );
}
